<template>
  <div class="layout">
    <div class="frame">
      <aside class="marketplace-links-desktop">
        <ul>
          <li v-if="authenticated">
            <SloLink :to="{name: 'marketplace-account-orders'}">
              <SloIcon name="TableList" />
              {{ 'Order History' | t }}
            </SloLink>
          </li>
          <li v-if="authenticated">
            <SloLink :to="{name: 'marketplace-account-subscriptions'}">
              <SloIcon name="ArrowsRotate" />
              {{ 'Subscriptions' | t }}
            </SloLink>
          </li>
          <li v-if="authenticated">
            <SloLink :to="{name: 'marketplace-account-returns'}">
              <SloIcon name="ArrowTurnDownLeft" />
              {{ 'Returns' | t }}
            </SloLink>
          </li>
          <li v-if="authenticated">
            <SloLink :to="{name: 'marketplace-account-saved-carts'}">
              <SloIcon name="CartShopping" />
              {{ 'Saved Carts' | t }}
            </SloLink>
          </li>
          <li v-if="authenticated">
            <SloLink :to="{name: 'marketplace-account-addresses'}">
              <SloIcon name="Book" />
              {{ 'Address Book' | t }}
            </SloLink>
          </li>
          <li v-if="authenticated">
            <SloLink :to="{name: 'marketplace-account-payments'}">
              <SloIcon name="CreditCard" />
              {{ 'Payment Details' | t }}
            </SloLink>
          </li>
          <li v-if="authenticated">
            <SloLink :to="{name: 'marketplace-account-profile'}">
              <SloIcon name="User" />
              {{ 'Personal Details' | t }}
            </SloLink>
          </li>
          <li>
            <SloLink to="/designspec">
              <SloIcon name="Folder" />
              {{ 'DesignSpec Projects' | t }}
            </SloLink>
          </li>
          <li v-if="authenticated">
            <SloLink @click.prevent="handleLogout">
              <SloIcon name="ArrowRightFromBracket" />
              {{ 'Sign Out' | t }}
            </SloLink>
          </li>
        </ul>
      </aside>
      <aside class="marketplace-links-mobile" @click="toggleDropDown" :class="dropDownOpen ? 'dropdown-active' : ''">
        <div class="close-dropdown">
          <SloIcon name="ChevronUp" />
        </div>
        <ul>
          <li v-if="authenticated">
            <SloLink :to="{name: 'marketplace-account-orders'}">
              <SloIcon name="TableList" />
              {{ 'Order History' | t }}
            </SloLink>
          </li>
          <li v-if="authenticated">
            <SloLink :to="{name: 'marketplace-account-subscriptions'}">
              <SloIcon name="ArrowsRotate" />
              {{ 'Subscriptions' | t }}
            </SloLink>
          </li>
          <li v-if="authenticated">
            <SloLink :to="{name: 'marketplace-account-returns'}">
              <SloIcon name="ArrowTurnDownLeft" />
              {{ 'Returns' | t }}
            </SloLink>
          </li>
          <li v-if="authenticated">
            <SloLink :to="{name: 'marketplace-account-saved-carts'}">
              <SloIcon name="CartShopping" />
              {{ 'Saved Carts' | t }}
            </SloLink>
          </li>
          <li v-if="authenticated">
            <SloLink :to="{name: 'marketplace-account-addresses'}">
              <SloIcon name="Book" />
              {{ 'Address Book' | t }}
            </SloLink>
          </li>
          <li v-if="authenticated">
            <SloLink :to="{name: 'marketplace-account-payments'}">
              <SloIcon name="CreditCard" />
              {{ 'Payment Details' | t }}
            </SloLink>
          </li>
          <li v-if="authenticated">
            <SloLink :to="{name: 'marketplace-account-profile'}">
              <SloIcon name="User" />
              {{ 'Personal Details' | t }}
            </SloLink>
          </li>
          <li>
            <SloLink to="/designspec">
              <SloIcon name="Folder" />
              {{ 'DesignSpec Projects' | t }}
            </SloLink>
          </li>
          <li v-if="authenticated">
            <SloLink @click.prevent="handleLogout">
              <SloIcon name="ArrowRightFromBracket" />
              {{ 'Sign Out' | t }}
            </SloLink>
          </li>
        </ul>
      </aside>
      <slot />
    </div>
    <SloModalView />
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import t from '../../main/i18n';
import SloLink from '../../../lib/components/SloLink.vue';
import SloIcon from '../../../lib/components/SloIcon.vue';

export default {
  components: {
    SloModalView: () => import('../../../lib/components/SloModalView.vue'),
    SloLink,
    SloIcon
  },
  data() {
    return {
      dropDownOpen: false
    };
  },
  filters: {
    t
  },
  computed: mapGetters('auth', ['authenticated']),
  methods: {
    ...mapActions('auth', ['logout']),
    toggleDropDown() {
      this.dropDownOpen = !this.dropDownOpen;
    },
    handleLogout() {
      this.logout('logout_request');
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../../scss/variables';
@import '../../../scss/system';

.layout {
  margin-block-end: 5.6rem;
}

.frame {
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 2.4rem;

  @media screen and (min-width: $screen-sm-min) {
    grid-template-columns: 245px 1fr;
  }

  @media (min-width: $screen-md) {
    grid-template-columns: 294px 1fr;
  }

  column-gap: 30px;
  -ms-grid-gap: 30px;
  margin-block-start: 5.6rem;

  & > aside {
    position: relative;
    isolation: isolate;
    z-index: 1;
    width: 100%;

    &.marketplace-links-mobile {
      position: relative;
      z-index: 100;
      height: 48px;
      border: 1px solid $color-blue-50;
      border-radius: 0.4rem;

      @media print {
        display: none;
      }

      @media screen and (min-width: $screen-sm) {
        display: none;
      }

      > ul {
        display: grid;
        row-gap: 0.8rem;
        height: 46px;
        transition: box-shadow 0.2s ease-in-out;
        overflow: hidden;

        li:has(.router-link-active) {
          order: -1;
        }

        a {
          position: absolute;
          top: 0;
          left: 0;
          height: 46px;
          background-color: $color-white;
          opacity: 0;
          visibility: hidden;
        }
      }

      &.dropdown-active {
        pointer-events: unset;

        .close-dropdown {
          .slo-icon {
            transform: rotate(180deg);
          }
        }

        > ul {
          position: relative;
          height: auto;
          border-radius: 0.4rem;
          box-shadow: 0 0 0 1px $color-gray-300, 0 4px 8px 0 rgba(0, 0, 0, 0.1);

          li {
            position: relative;
            z-index: 1;
          }

          a {
            position: relative;
            opacity: 1;
            visibility: visible;
            pointer-events: visible;
          }
        }
      }

      .close-dropdown {
        position: absolute;
        top: 48%;
        right: 0.8rem;
        z-index: 10;
        display: flex;
        align-content: center;
        justify-content: center;
        padding: 0.4rem;
        transform: translateY(-50%);
        cursor: pointer;

        @media screen and (min-width: $screen-sm-min) {
          display: none;
        }

        .slo-icon {
          transform-origin: center;
          transition: transform 0.15s cubic-bezier(0.4, 0, 1, 1);
        }
      }
    }

    &.marketplace-links-desktop {
      display: none;

      @media print {
        display: none;
      }

      @media screen and (min-width: $screen-sm) {
        position: sticky;
        top: calc(var(--header-height, 80px) + 3.2rem);
        display: block;
      }
    }

    @media screen and (min-width: $screen-sm-min) {
      height: max-content;
      pointer-events: unset;
    }

    @media print {
      display: none;
    }
  }

  & > aside > ul {
    display: flex;
    flex-direction: column;
    row-gap: 0.8rem;
    width: 100%;
    height: auto;
    background: white;
    padding: 0;
    margin: 0;

    li {
      @include text('base');
      width: 100%;
      margin: 0;
      padding: 0;
      list-style: none;

      a {
        display: flex;
        align-items: center;
        justify-content: start;
        column-gap: 0.8rem;
        width: 100%;
        background-color: transparent;
        color: $color-gray-600;
        padding: 0.8rem;
        transition: background-color 0.15s ease-in, color 0.15s ease-in;

        &:after {
          content: none;
        }

        &:hover {
          background-color: $color-blue-50;
          color: $color-blue-400;
        }

        &.router-link-active {
          background-color: $color-blue-50;
          color: $color-blue-400;
          opacity: 1;
          visibility: visible;
          z-index: 1;
        }

        @media (min-width: $screen-sm-min) {
          position: relative;
          z-index: 1;
          opacity: 1;
          visibility: visible;
          pointer-events: visible;
        }
      }
    }
  }

  & > section {
    margin-left: 30px;
    background: white;

    @supports (display: grid) {
      margin-left: 0;
    }

    & > header {
      margin-block-end: 3.2rem;
      overflow: visible;

      h2 {
        font-weight: normal;
        font-size: 3.6rem;
        margin: 0;

        @media (min-width: $screen-sm) {
          @include text('3xl');
        }
      }
    }
    & > header > div {
      display: flex;
      flex-direction: column;
      gap: 16px;
      align-items: center;

      @media screen and (min-width: $screen-sm-min) {
        flex-direction: row;
      }

      h1 {
        margin-right: auto;
      }
    }

    > main {
      min-height: 380px;
      margin-left: 30px;
      display: flex;
      flex-direction: column;

      @supports (display: grid) {
        margin: 0;
        margin-top: 0;
      }
    }
  }

  @media print {
    grid-template-columns: 1fr;
  }

  .marketplace-heading {
    margin-top: 0;
    font-weight: normal;
    font-size: 3.6rem;

    @media (min-width: $screen-sm) {
      @include text('3xl');
    }
  }
}

</style>

<style lang="scss">
@import '../../../scss/variables';
@import '../../../scss/system';

.frame {
  .marketplace-heading {
    margin-top: 0;
    font-weight: normal;
    font-size: 3.6rem;

    @media (min-width: $screen-sm) {
      @include text('3xl');
    }
  }
}
</style>
